import { Extension } from "@tiptap/core";
import "@tiptap/extension-text-style";

declare module "@tiptap/core" {
    interface Commands<ReturnType> {
        fontWeight: {
            setFontWeight: (weight: string) => ReturnType;
            unsetFontWeight: () => ReturnType;
        };
    }
}

/** Adds a `font-weight` style on the textStyle mark (like FontFamily). */
export const FontWeight = Extension.create({
    name: "fontWeight",

    addOptions() {
        return { types: ["textStyle"] };
    },

    addGlobalAttributes() {
        return [
            {
                types: this.options.types,
                attributes: {
                    fontWeight: {
                        default: null,
                        parseHTML: (el: HTMLElement) =>
                            el.style.fontWeight || null,
                        renderHTML: (attrs: { fontWeight?: string }) =>
                            attrs.fontWeight
                                ? { style: `font-weight: ${attrs.fontWeight}` }
                                : {},
                    },
                },
            },
        ];
    },

    addCommands() {
        return {
            setFontWeight:
                (weight: string) =>
                ({ chain }) =>
                    chain().setMark("textStyle", { fontWeight: weight }).run(),
            unsetFontWeight:
                () =>
                ({ chain }) =>
                    chain()
                        .setMark("textStyle", { fontWeight: null })
                        .removeEmptyTextStyle()
                        .run(),
        };
    },
});
